//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ContentHeader from 'components/ContentHeader'
import Vue from 'vue'
import DateRangePicker from 'components/DateRangePicker'

const Pagination = require('../plugins/vue-bootstrap-paginator').default

export default {
  components: {
    ContentHeader,
    Pagination,
    DateRangePicker
  },
  data () {
    return {
      searchRoomName: '',
      searchSessionID: '',
      searchStatus: '',
      searchPayStatus: '',
      searchExchangeStatus: '',
      searchDate: {startDate: '', endDate: '', startDateText: '', endDateText: ''},
      dateOptions: JSON.parse(JSON.stringify(this.dateRangePickerOptions)),
      canSaveSessionGold: false,
      canRefundOrder: false,
      gameSessionList: [],
      totalItems: 0,
      currentPage: 1,
      perPage: 0,
      appointPage: 1,
      lastPage: 0
    }
  },
  created () {
  },
  mounted () {
    this.getGameSession()
  },
  computed: {
  },
  methods: {
    // 获取游戏记录
    getGameSession: function (page = 1) {
      var params = {
        page: page,
        room_name: this.searchRoomName,
        game_session_id: this.searchSessionID,
        status: this.searchStatus,
        pay_status: this.searchPayStatus,
        exchange_status: this.searchExchangeStatus,
        sdate: this.searchDate.startDateText,
        edate: this.searchDate.endDateText
      }
      Vue.http.get(this.serviceUrl('api/game/session/info'), {params: params}).then((response) => {
        let resp = response.data
        this.gameSessionList = resp.gameSessionList.data;
        this.totalItems = resp.gameSessionList.total;
        this.currentPage = resp.gameSessionList.current_page;
        this.perPage = resp.gameSessionList.per_page;
        this.lastPage = resp.gameSessionList.last_page;
      });
    },
    // 分页跳转
    pageChanged: function (page = 1) {
      this.getGameSession(page);
    },
    // 跳转指定页面
    pageJumped: function () {
      var appointPage = parseInt(this.appointPage) < this.lastPage ? parseInt(this.appointPage) : this.lastPage;
      this.getGameSession(appointPage);
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/PageRoomSession.vue